type THandlerGeolocation = {
  successFunction: (position?: GeolocationPosition | undefined) => void
  errorFunction?: (err: GeolocationPositionError) => void
}

// запросить геолокацию пользователя
export const getUserGeolocation = ({
  successFunction,
  errorFunction,
}: THandlerGeolocation) => {
  const initialError = (err: GeolocationPositionError) => {
    console.warn(`ERROR(${err.code}): ${err.message}`)

    if (errorFunction) {
      errorFunction(err)
    }
  }

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  }

  if (!/(safari)/i.test(navigator.userAgent)) {
    navigator.permissions
      .query({ name: 'geolocation' })
      .then(function (result) {
        if (result.state === 'granted' || result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(
            successFunction,
            initialError,
            options,
          )
        }
      })
  } else {
    navigator.geolocation.getCurrentPosition(
      position => {
        successFunction(position)
      },
      error => {
        initialError(error)
        console.error(`Ошибка получения местоположения: ${error.message}`)
      },
      {
        enableHighAccuracy: true,
      },
    )
  }
}
